import axios from "axios";

function getCompanyNames(){
    axios.post('fetchCompanyNames_db')
         .then((result)=>{
            var companies = [];
            companies = result.data;
            if (companies.length == 0) {
                $("#company").find('option').remove();
            }
            else {
                $.each(companies, function (key, value) {
                    if (value.length > 0) {
                        $("#company").find('option').remove();
                    }
                })
                $.each(companies, function (key, value) {
                    if (value.length > 0) {
                        $(".company_name").append("<option value=" + value + ">" + value + "</value>");
                    }
                })
            }
         }) 
}

function getTemplateNames(company,type,subtype){
    var params={'company':company,'type':type,'subtype':subtype};
  
    axios.post('fetchTemplateNames_popup',params)
         .then((result)=>{
                var templates = [];
                templates = result.data;
                if (templates.length == 0) {
                    $("#Name").find('option').remove();
                }
                else {
                    $.each(templates, function (key, value) {
                        if (value.length > 0) {
                            $("#Name").find('option').remove();
                        }
                    })
                    $.each(templates, function (key, value) {
                        if (value.length > 0) {
                            $(".template_name").append("<option value=" + value + ">" + value + "</value>");
                        }
                    })
                }
         })
}

function getJsonTemplate_Popup(_this,params){
    axios.post('fetchTemplate_popup',params)
    .then((result)=>{
        _this.template_data=result.data.template_data;
        alert(_this.template_data);
    });
}

export{getCompanyNames,getTemplateNames,getJsonTemplate_Popup}